import { connect } from 'react-redux';

import { ThunkDispatch } from 'modules/shared/redux/utils/type';
import { listModule } from 'modules/shared/redux';
import { RootState } from 'modules/shared/redux/store';

import {
    ProductThumbnailOwnProps,
    ProductThumbnailStateProps,
    ProductThumbnailDispatchProps,
} from './product-thumbnail-type';

const mapStateToProps = (
    state: RootState,
    props: ProductThumbnailOwnProps,
): ProductThumbnailOwnProps & ProductThumbnailStateProps => {
    const isAuthenticated = state && state.authentication ? !!state.authentication.loggedInFolder : false;
    if (!props || !props.product || !props.product.variantId) {
        return { isAuthenticated, ...props };
    }

    if (
        !state ||
        !state.list ||
        !state.list.currentList ||
        !state.list.currentList.elements ||
        state.list.currentList.elements.length === 0
    ) {
        return { isAuthenticated, ...props };
    }

    const currentListElement = state.list.currentList.elements.find(
        e => e.variantId && e.variantId === props.product.variantId && e.quantity > 0,
    );

    return {
        ...props,
        currentListElement: currentListElement
            ? {
                  ...currentListElement,
              }
            : undefined,
        isAuthenticated,
    };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = (dispatch: ThunkDispatch<RootState>): ProductThumbnailDispatchProps => ({
    updateQuantity: (variantId, quantity) =>
        dispatch(listModule.action.updateElementsQuantity([{ variantId, quantity }])),
});

const reduxConnect = connect<
    ProductThumbnailStateProps,
    ProductThumbnailDispatchProps,
    ProductThumbnailOwnProps,
    RootState
>(mapStateToProps, mapDispatchToProps);

const enhancer = reduxConnect;

export default enhancer;
